import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    progressWrap: {
      position: 'relative',
      width: '100%',
      height: 6,
      background: 'rgba(134, 134, 241, 0.364706)',
      borderRadius: 5,
    },
    progressValue: {
      position: 'absolute',
      left: 0,
      top: 'calc(100% + 7px)',
      bottom: 'unset',
      color: colorsPalette.white,
      fontSize: 13,
      lineHeight: 1,
      zIndex: 1,

      [theme.breakpoints.up('md')]: {
        fontWeight: 'bold',
        top: 'unset',
        bottom: 'calc(100% + 7px)',
      },
    },
    progressLabel: {
      color: colorsPalette.gray,
      textTransform: 'uppercase',
      fontWeight: 'normal',
      fontSize: 12,
      paddingLeft: 4,
    },
    progressString: {
      position: 'absolute',
      right: 0,
      top: 'calc(100% + 4px)',
      bottom: 'unset',

      [theme.breakpoints.up('md')]: {
        top: 'unset',
        bottom: 'calc(100% + 4px)',
      },
    },
    progress: {
      position: 'absolute',
      background: colorsPalette.violet,
      borderRadius: 5,
      height: 6,
      left: 0,
      top: 0,
    },
  }),
);

export default useStyles;
